import script from "./ReferenceSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__